import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-39496585"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "login-form p-d-flex p-flex-column" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Authorization", -1))
const _hoisted_3 = { class: "link-login p-mt-6" }
const _hoisted_4 = { class: "p-d-flex p-justify-around positioning" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "© 2022 Gameinfluencer GmbH |", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EmailConnect = _resolveComponent("EmailConnect")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_EmailConnect, {
      "sign-in": true,
      onSignIn: _ctx.handleEmailSignIn
    }, null, 8, ["onSignIn"]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", {
          class: "footer",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: 'terms-of-use' })))
        }, " TERMS OF USE |"),
        _createElementVNode("div", {
          class: "footer",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push({ name: 'legacy-of-notice' })))
        }, "LEGAL NOTICE |"),
        _createElementVNode("div", {
          class: "footer",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push({name: 'privace-policy'})))
        }, " Privacy Policy |")
      ])
    ])
  ]))
}